import {
  TopicPartQuestion,
  TopicPartQuestionFormData,
} from "../../core/topicPartQuestion/entities/TopicPartQuestion";
import { pb } from "../pocketbase/pocketbase";
import { RepositoryInterface } from "../interfaces/RepositoryInterface";

const collection = "topicPartQuestions";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapRecordToTopicPartQuestion(record: any): TopicPartQuestion {
  return {
    id: record.id,
    topicPartId: record.topicPartId ?? record.topicPartId,
    text: record.text,
    answerType: record.answerType ?? record.answerType,
    answers: record.answers,
    rank: record.rank,
    comments: record.comments,
  };
}

function topicPartQuestionFormToPayload(
  data: TopicPartQuestionFormData,
): Record<string, unknown> {
  return {
    topicPartId: data.topicPartId,
    text: data.text,
    answerType: data.answerType,
    answers: data.answers ?? [],
    comments: data.comments,
  };
}

export const topicPartQuestionRepository: RepositoryInterface<
  TopicPartQuestion,
  TopicPartQuestionFormData
> = {
  async getAll(topicPartId: string): Promise<TopicPartQuestion[]> {
    const records = await pb.collection(collection).getFullList({
      filter: `topicPartId = "${topicPartId}"`,
      sort: "rank",
    });

    return records.map(mapRecordToTopicPartQuestion);
  },

  async getOne(id: string): Promise<TopicPartQuestion> {
    const record = await pb.collection(collection).getOne(id.toString());
    return mapRecordToTopicPartQuestion(record);
  },

  async addUpdate(
    data: TopicPartQuestionFormData,
    id: string | null,
  ): Promise<TopicPartQuestion> {
    const payload = topicPartQuestionFormToPayload(data);
    let record;
    if (id) {
      record = await pb.collection(collection).update(id.toString(), payload);
    } else {
      record = await pb.collection(collection).create(payload);
    }

    return mapRecordToTopicPartQuestion(record);
  },

  async delete(id: string): Promise<void> {
    await pb.collection(collection).delete(id.toString());
  },

  async updateOrder(list: TopicPartQuestion[]): Promise<void> {
    const updates = list.map((topicPartQuestion, index) => ({
      id: topicPartQuestion.id,
      rank: index + 1,
    }));

    await pb.send("/api/reorder", {
      method: "POST",
      body: {
        collection,
        data: updates,
      },
    });
  },
};
